import type { MessageBlock } from "@/lib/chat-types";
import { renderInlineBold } from "./RenderInlineBold";
import { ThinkingCard } from "./ThinkingCard";
import { AttachmentCard } from "./AttachmentCard";
import { FindingsGrid } from "./FindingsGrid";
import { CitationBlock } from "./CitationBlock";
import { ChecklistBlock } from "./ChecklistBlock";
import { ReportProgressCard } from "./ReportProgressCard";
import { TableBlock } from "./TableBlock";
import { MarkdownTextBlock } from "./MarkdownTextBlock";

export function BlockRenderer({
  block,
  isLatestMessage = false,
  animateText = false,
}: {
  block: MessageBlock;
  isLatestMessage?: boolean;
  animateText?: boolean;
}) {
  switch (block.type) {
    case "text":
      return <MarkdownTextBlock content={block.content} animate={animateText} />;

    case "heading":
      if (block.level === 2)
        return <h2 className="text-base font-semibold leading-snug mt-4 mb-1" style={{ fontFamily: "var(--font-display)" }}>{block.content}</h2>;
      return <h3 className="text-sm font-semibold leading-snug mt-3 mb-0.5" style={{ fontFamily: "var(--font-display)" }}>{block.content}</h3>;

    case "bullets":
      return (
        <ul className="my-1 pl-1">
          {block.items.map((item, i) => (
            <li key={i} className="flex gap-2 text-sm leading-relaxed mb-1">
              <span className="shrink-0 mt-0.5 text-[var(--color-fg-tertiary)]">&bull;</span>
              <span>{renderInlineBold(item)}</span>
            </li>
          ))}
        </ul>
      );

    case "table":
      return <TableBlock table={block.table} />;

    case "thinking":
      return <ThinkingCard thinking={block.thinking} />;

    case "attachment":
      return <AttachmentCard attachment={block.attachment} />;

    case "findings":
      return <FindingsGrid findings={block.findings} />;

    case "citation":
      return <CitationBlock citation={block.citation} />;

    case "checklist":
      return <ChecklistBlock checklist={block.checklist} />;

    case "report-progress":
      return <ReportProgressCard data={block.reportProgress} defaultExpanded={isLatestMessage} />;

    case "status":
      return null;

    default:
      return null;
  }
}
